module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/trolley_animation@2x-e5fe56f65ec366328f4b21810aa449ef.png";